export const LIST_MIN_HEIGHT = 301;
export const LIST_MAX_HEIGHT = 532;

export const enum STEP {
  step1 = 'select-saved-lists',
  step2 = 'edit-saved-lists-creators',
}

export const enum TYPE {
  agency = 'agency-lists',
  my = 'my-lists',
}

export const TYPE_NAME = {
  [TYPE.agency]: 'Agency Lists',
  [TYPE.my]: 'My Lists',
} as const;

export const PAGE_SIZE = 10;
